<!--
  관리자 설정
  관리자/그룹 편집 > 일반설정

-->
<template>
  <div class="contents-row">
    <!-- 컨텐츠 패널 시작 -->
    <div class="portlet">
        <div class="contents-row">
          <!-- 테이블 시작 -->
          <table class="bs-table table-bordered-none">
            <colgroup>
              <col width="25%"/>
              <col width="auto"/>
            </colgroup>
            <tbody>
              <tr v-if="!externalAuth">
                <td class="td-head">{{ $t('cmn.group') }} <span class="textR">*</span></td>
                <td>
                  <div class="inline-group">
                    <q-input v-model="adminGeneral.parent_admin_name"
                             disable
                             class="bs bs-q-input bs-q-input-default"
                             style="width:210px;" >
                    </q-input>
                  </div>
                </td>
                <td rowspan="7">
                  <div class="inline-group">
                    <div>
                      <template v-if="imageStatus===1 && adminDetail.img_cnt < 1">
                        <div class="text-center" style="display:inline-block; width:180px;">
                          <div class="img-preview" style="width:100%; height:225px;">
                            <span class="img-preview-text" style="left:0; right:0;">{{ $t('sm.deviceConfig_deviceConfigSep_noImage') }}</span>
                          </div>
                        </div>
                      </template>
                      <template v-if="imageStatus===1 && adminDetail.img_cnt > 0">
                        <img :src="adminImageUrl" style="max-width: 400px; height: 225px;">
                      </template>
                      <template v-if="imageStatus===2">
                        <img :src="previewFile" style="max-width: 400px; height: 225px;">
                      </template>
                    </div>
                  </div>
                  <div class="inline-group">
                    <!-- 이미지 업로드 -->
                    <q-uploader
                      ref='refAdminImage'
                      name='adminImage'
                      @add="onFileSelected"
                      hide-upload-button
                      hide-upload-progress
                      :disable="isReadOnly"
                      @remove:cancel="onFileRemoved"
                      :extensions="fileExtensions"
                      color="amber"
                      class="bs bs-q-uploader bs-q-uploader-default"
                      style="width:270px;"
                      url="adminImageUrl"
                    >
                    </q-uploader>
                    <div>
                      <q-btn :label="$t('sm.adminGroupSettings_profilePicRemove')"
                             color="primary"
                             outline="outline"
                             :disable="isReadOnly"
                             class="bs bs-q-btn-sm bs-q-btn-line"
                             style="margin-left:10px;"
                             @click="onRemovePhoto">
                      </q-btn>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!externalAuth">
                <td class="td-head">ID <span class="textR">*</span></td>
                <td>
                  <div class="inline-group">
                    <q-input v-model="adminDetail.admin_login_uname" disable
                             class="bs bs-q-input bs-q-input-default" style="width:210px;" >
                    </q-input>
                  </div>
                </td>
              </tr>
              <tr v-if="!externalAuth">
                <td class="td-head">{{ $t('cmn.userPassword') }} <span class="textR">*</span></td>
                <td>
                  <div class="inline-group">
                    <q-input v-model="adminDetail.admin_login_pw"
                             disable
                             type="password"
                             name="password"
                             no-pass-toggle
                             :maxLength="32"
                             data-vv-scope="main"
                             :placeholder="placeholderStr"
                             v-validate="'required|isValidAdminPasswd:' + adminDetail.admin_login_uname"
                             :error="errors.has('main.password')"
                             class="bs bs-q-input bs-q-input-default"
                             style="width:210px;">
                    </q-input>
                    <q-btn :label="$t('cmn.changingPassword')"
                           color="primary"
                           outline="outline"
                           class="bs bs-q-btn-sm bs-q-btn-line"
                           :disable="isReadOnly"
                           @click="onPasswordChange">
                    </q-btn>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="td-head">{{ $t('cmn.name') }} <span class="textR">*</span></td>
                <td>
                  <div class="inline-group">
                    <q-input v-model="adminGeneral.admin_name" :disable="isReadOnly"
                             name="admin_name"
                             data-vv-scope="user"
                             :maxLength="32"
                             v-validate="`required|isValidNameLenth:${2},${32}`"
                             :error="errors.has('user.admin_name')"
                             class="bs bs-q-input bs-q-input-default" style="width:210px;">
                      <tool-tip minLength="2" maxLength="32" />
                    </q-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="td-head">{{ $t('cmn.userMail') }}</td>
                <td>
                  <div class="inline-group">
                    <q-input v-model="adminDetail.admin_email"
                             :disable="isReadOnly"
                             maxLength="128"
                             name="email"
                             data-vv-scope="user"
                             :error="errors.has('user.email')"
                             v-validate="'isValidEmail'"
                             class="bs bs-q-input bs-q-input-default"
                             style="width:210px;">
                      <tool-tip maxValue="128"></tool-tip>
                    </q-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="td-head">{{ $t('cmn.depart') }}</td>
                <td>
                  <div class="inline-group">
                    <q-input v-model="adminDetail.admin_depart_name"
                             :disable="isReadOnly"
                             maxLength="32"
                             class="bs bs-q-input bs-q-input-default"
                             style="width:210px;" >
                      <tool-tip maxValue="32"></tool-tip>
                    </q-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="td-head">{{ $t('cmn.tel') }}</td>
                <td>
                  <div class="inline-group">
                    <q-input v-model="adminDetail.admin_phone"
                             :disable="isReadOnly"
                             maxLength="16"
                             name="phone"
                             data-vv-scope="user"
                             :error="errors.has('user.phone')"
                             v-validate="'isOnlyNumberHyphen'"
                             class="bs bs-q-input bs-q-input-default"
                             style="width:210px;">
                      <tool-tip maxValue="16"></tool-tip>
                    </q-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="td-head">{{ $t('cmn.description') }}</td>
                <td colspan=2>
                  <div class="inline-group">
                    <q-input v-model="adminDetail.admin_desc"
                             :disable="isReadOnly"
                             maxLength="128"
                             class="bs bs-q-input bs-q-input-default"
                             style="width:210px;">
                      <tool-tip maxValue="128"></tool-tip>
                    </q-input>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 테이블 끝 -->
        </div>
      </div>

  </div>
</template>
<script>
import {createNamespacedHelpers} from 'vuex'
const {mapState} = createNamespacedHelpers('system/adminSettings/adminGroupSettings')
// import {refsFind} from '~/utils/admin-common'
import path from 'path'

export default {
  name: 'AdminGeneral',
  props: {
    isReadOnly: {
      type: Boolean,
      default: false
    },
    externalAuth: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      text: null,
      uploadFile: null,
      isAddFile: null,
      fileExtensions: '.gif,.jpg,.jpeg,.png',
      placeholderStr: '*********',
      imageStatus: 1, // 1. upload file 존재하는 상태, 2. upload file 존재하지 않는 상태.
      previewFile: ''
    }
  },
  methods: {
    onFileSelected (file) {
      if (this.isReadOnly) {
        return
      }
      const maxFileSize = 10 * 1024 * 1024 /* =10M */
      this.uploadTotalFileSize = file[0].size
      if (maxFileSize < this.uploadTotalFileSize) {
        this.onFileRemoved()
        this.$alertPopUp.show(this.$t('msg.maxFileSizeWarning', { fileSize: '10M' }))
        return
      }

      const fileName = file[0].name
      const fileExt = path.extname(fileName)

      if (this.fileExtensions.indexOf(fileExt.toLowerCase()) === -1) {
        this.$alertPopUp.show(this.$t('msg.fileExtensionWarning', {extension: this.fileExtensions}))
        this.$refs.refAdminImage.reset()
        return
      }

      if (file[0].name !== '') {
        this.isAddFile = 'N'
        this.uploadFile = file[0]
        this.imageStatus = 2
        this.previewFile = file[0].__img.src
      } else {
        this.onFileRemoved()
      }
    },
    onFileRemoved () {
      this.isAddFile = null
      this.uploadFile = null
      this.imageStatus = 1
      this.previewFile = ''
      if (typeof this.$refs.refAdminImage !== 'undefined') {
        this.$refs.refAdminImage.reset()
      }
    },
    onPasswordChange () {
      this.$emit('onChangePassword')
    },
    onRemovePhoto () {
      this.onFileRemoved()
      this.$emit('onPhotoRemove')
    },
    onGeneralSave () {
      this.$emit('onSave')
    }
  },
  computed: {
    ...mapState([
      'adminGeneral',
      'adminImageUrl',
      'adminDetail'
    ])
  },
  watch: {}
}
</script>

